import styled from '@emotion/styled'
import { Box, Chip, TableContainer } from '@mui/material'
import { colors } from '@resiliatech/birdsong'

export const AcademyDigestContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  width: 100%;
`
export const AcademyTableContainer = styled(TableContainer)`
  max-height: 400px;
  overflow: auto;
`

export const StatusChip = styled(Chip)`
  background-color: ${colors.feedback.infoLight};
  color: ${colors.illustration.darkBlue};
`
